import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import closeIcon from "../../../assets/img/cross-icon.svg";
import fileIcon from "../../../assets/img/file.svg";
import pdfIcon from "../../../assets/img/file-icon-pdf.svg";
import { customModalStyles } from "../../utils/styles";
import { openBase64NewTab } from "../../utils/get";
import { hideGreyBackground, showGreyBackground } from "../../utils/windows";

const modalStyles = customModalStyles(20);
modalStyles.content.padding = 0;
modalStyles.overlay = {
  position: "fixed",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: 10000,
  overflowY: "auto",
  overflowX: "hidden"
};

const JustificacionCierreMensualMobileModal = ({
  isOpen,
  closeModal,
  info,
  selectedTable,
  selectedAction,
  selectedEds,
  selectedPeriodo,
  pagador,
  callServiceHandler,
  getCierreMensual,
  estadoCierre,
  title,
  subtitle,
  rows = []
}) => {
  const [observacion, setObservacion] = useState("");
  const [uploadedFile, setUploadedFile] = useState();
  const [base64File, setBase64File] = useState();
  const [fileExist, setFileExist] = useState(false);
  const [encodedFile, setEncodedFile] = useState();
  const [fileName, setFileName] = useState();

  const hiddenFileInput = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    showGreyBackground();
    return () => hideGreyBackground();
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    setObservacion("");
    setUploadedFile();
    setBase64File();
    setFileExist(false);
    setEncodedFile();
    setFileName();

    if (selectedAction === "ver") {
      const id = selectedTable === "VENTAS" ? info?.ID_JUSTIFICACION : info?.id_justificacion;
      if (id) {
        getJustificacion(id);
      }
    }
  }, [isOpen]);

  useEffect(() => {
    if (uploadedFile) {
      fileToBase64(uploadedFile, (err, result) => {
        if (result) {
          setBase64File(result);
        }
      });
      setFileName(uploadedFile.name);
    } else {
      setBase64File();
    }
  }, [uploadedFile]);

  const getJustificacion = async (id) => {
    const url = process.env.REACT_APP_FLUCTUACIONES_API + `/fluctuaciones/cierre-mensual-leer-justificacion?ID_EDS=${selectedEds}&ID_PERIODO=${selectedPeriodo}&ID_PAGADOR=${pagador}&ID_JUSTIFICACION=${id}`;
    let response = await callServiceHandler(url, "GET");

    if (response !== "error") {
      setObservacion(response.data.observacion || "");

      if (response.data.adjunto && response.data.adjunto.length > 0) {
        setFileExist(true);
        setFileName(response.data.nombre_archivo);
        setEncodedFile(response.data.adjunto);
        setBase64File(`data:application/pdf;base64,${response.data.adjunto}`);
      }
    }
  };

  const fileToBase64 = (file, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(null, reader.result);
    };
    reader.onerror = function (error) {
      cb(error, null);
    };
  };

  const changeObservacion = (e) => {
    if (e.target.value.length <= 250) {
      setObservacion(e.target.value);
    }
  };

  const handleUploadFile = () => {
    hiddenFileInput.current.click();
  };

  const handleDeleteDocument = () => {
    setUploadedFile();
    setBase64File();
    setFileName();
    setFileExist(false);
    setEncodedFile();
  };

  const enviarJustificacion = async () => {
    const url = process.env.REACT_APP_FLUCTUACIONES_API + "/fluctuaciones/cierre-mensual-ingresar-justificacion";

    const data = {
      ID_EDS: selectedEds,
      PAGADOR: pagador,
      PERIODO: selectedPeriodo,
      INFO_JUSTIFICACION: info,
      OBSERVACIONES: observacion,
      ARCHIVO: base64File,
      NOMBRE_ARCHIVO: fileName
    };

    let result = await callServiceHandler(url, "POST", JSON.stringify(data));

    if (result !== "error") {
      closeModal();
      getCierreMensual();
    }
  };

  const isReadOnly = estadoCierre === "EN REVISIÓN" && selectedAction === "ver";
  const canSave = selectedAction === "editar" || estadoCierre !== "EN REVISIÓN";
  const saveDisabled = observacion.length === 0;

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={modalStyles}
      className="responsive-modal cierre-mensual-detalle-modal cierre-mensual-justificacion-mobile-modal"
      overlayClassName="ReactModal__Overlay cierre-mensual-responsive-modal-overlay"
    >
      <div className="cierre-mensual-detalle-modal-container cierre-mensual-justificacion-modal-container">
        <div className="cierre-mensual-detalle-modal-header">
          <div>
            <div className="cierre-mensual-detalle-modal-title">{title}</div>
            {subtitle && <div className="cierre-mensual-detalle-modal-subtitle">{subtitle}</div>}
          </div>
          <button className="cierre-mensual-detalle-modal-close" onClick={closeModal}>
            <img src={closeIcon} alt="Cerrar" />
          </button>
        </div>

        <div className="cierre-mensual-detalle-modal-separator" />

        <table className="cierre-mensual-detalle-modal-table">
          <thead>
            <tr>
              <th>Detalle</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr className="separator-table-row">
              <th colSpan="100%" />
            </tr>
            {rows.map((row, index) => (
              <React.Fragment key={`justificacion-cierre-mensual-row-${row.value}-${row.label}`}>
                <tr>
                  <td>{row.label}</td>
                  <td className="align-right">
                    {row.isPill ?
                      <span className="cierre-mensual-detalle-modal-pill">{row.value}</span>
                      :
                      row.value
                    }
                  </td>
                </tr>
                {index < rows.length - 1 && (
                  <tr className="separator-table-row">
                    <th colSpan="100%" />
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>

        <div className="cierre-mensual-justificacion-warning">
          <span className="cierre-mensual-justificacion-warning-icon">!</span>
          <span>Los valores excedieron la tolerancia permitida, favor ingresar justificación.</span>
        </div>

        <div className="cierre-mensual-justificacion-input-area">
          <textarea
            className="cierre-mensual-justificacion-mobile-text"
            disabled={isReadOnly}
            value={observacion}
            onChange={changeObservacion}
            maxLength="250"
            placeholder="Ingrese aquí sus comentarios"
          />
          <div className="cierre-mensual-justificacion-counter">{observacion.length}/250</div>
        </div>

        <div className="cierre-mensual-justificacion-file-title">
          <span>ARCHIVOS ADJUNTOS</span>
          <div />
        </div>

        {!uploadedFile && !fileExist &&
          <button className="cierre-mensual-justificacion-upload-button" onClick={handleUploadFile} disabled={isReadOnly}>
            <img src={fileIcon} alt="" />
            Adjuntar archivo PDF
          </button>
        }

        {uploadedFile &&
          <div className="cierre-mensual-justificacion-file-card">
            <div className="cierre-mensual-justificacion-file-info">
              <img src={pdfIcon} alt="" />
              <span>{uploadedFile.name}</span>
            </div>
            <button onClick={handleDeleteDocument}>×</button>
          </div>
        }

        {fileExist &&
          <div className="cierre-mensual-justificacion-file-card">
            <div className="cierre-mensual-justificacion-file-info" onClick={() => openBase64NewTab(encodedFile, "application/pdf")}>
              <img src={pdfIcon} alt="" />
              <span>{fileName}</span>
            </div>
            {!isReadOnly && <button onClick={handleDeleteDocument}>×</button>}
          </div>
        }

        <input
          className="hidden-file-input"
          type="file"
          ref={hiddenFileInput}
          accept="application/pdf"
          onChange={(e) => {
            setUploadedFile(e.target.files[0]);
          }}
          onClick={(event) => {
            event.target.value = null;
          }}
        />

        {canSave &&
          <button className="cierre-mensual-justificacion-save-button" disabled={saveDisabled} onClick={enviarJustificacion}>
            Guardar Justificación
          </button>
        }

        <button className="cierre-mensual-justificacion-cancel-button" onClick={closeModal}>
          Cancelar
        </button>
      </div>
    </Modal>
  );
};

export default JustificacionCierreMensualMobileModal;
